'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCookie;
function getCookie(name) {
  var value = '; ' + window.document.cookie;
  var splitCookies = value.split(';');
  if (splitCookies.length) {
    for (var i = 0; i < splitCookies.length; i++) {
      var parts = splitCookies[i].split('=');
      if (parts.length === 2 && parts[0].trim() === name) {
        return parts[1];
      }
    }
  }
  return null;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/utils/getCookie.js
// module id = 41
// module chunks = 1